var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 3.82593,
    y: 3.04639,
    width: 72.6047,
    height: 74.0683,
    rx: 16,
    stroke: "#CCFF95",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7944 15.2952C38.6026 15.3464 37.4733 15.8424 36.6293 16.6853L32.099 21.2156H25.6946L25.337 21.2299C24.1377 21.3201 23.0167 21.8601 22.1988 22.7418C21.3808 23.6234 20.9261 24.7816 20.9259 25.9843V32.3887L16.3956 36.919L16.119 37.2218C15.3509 38.1352 14.9532 39.3033 15.0044 40.4957C15.0556 41.688 15.552 42.8178 16.3956 43.6619L20.9259 48.1922V54.5966L20.9378 54.9543C21.0281 56.154 21.5684 57.2752 22.4506 58.0933C23.3327 58.9113 24.4915 59.3657 25.6946 59.3653H32.1014L36.6317 63.8956L36.9345 64.1722C37.8479 64.9403 39.016 65.338 40.2084 65.2868C41.4007 65.2356 42.5305 64.7392 43.3746 63.8956L47.9049 59.3653H54.3069L54.6622 59.3534C55.8619 59.2632 56.9831 58.7228 57.8012 57.8406C58.6193 56.9585 59.0736 55.7997 59.0732 54.5966V48.1922L63.6035 43.6619L63.8825 43.3591C64.6506 42.4457 65.0483 41.2776 64.9971 40.0852C64.9459 38.8929 64.4495 37.7631 63.6059 36.919L59.0756 32.3887V25.9843L59.0613 25.6266C58.9711 24.4274 58.4311 23.3064 57.5494 22.4884C56.6678 21.6704 55.5096 21.2158 54.3069 21.2156H47.9025L43.3722 16.6877L43.0671 16.4087C42.1538 15.6413 40.9861 15.244 39.7944 15.2952ZM37.2233 43.2164L47.3425 33.0972C47.7922 32.6629 48.3945 32.4225 49.0197 32.428C49.6449 32.4334 50.2429 32.6842 50.685 33.1262C51.1271 33.5683 51.3778 34.1663 51.3833 34.7915C51.3887 35.4167 51.1484 36.019 50.714 36.4687L39.0784 48.1067C38.8348 48.3504 38.5456 48.5437 38.2273 48.6756C37.909 48.8075 37.5679 48.8754 37.2233 48.8754C36.8788 48.8754 36.5376 48.8075 36.2193 48.6756C35.901 48.5437 35.6119 48.3504 35.3683 48.1067L29.6363 42.3747C29.1889 41.9276 28.9374 41.3211 28.9372 40.6886C28.937 40.0561 29.188 39.4495 29.6351 39.0021C30.0822 38.5547 30.6887 38.3032 31.3212 38.303C31.9537 38.3027 32.5604 38.5538 33.0078 39.0009L37.2233 43.2164Z",
    fill: "#CCFF95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.a47f37c1389189f12a4a109629e8209b.svg";
export { ForwardRef as ReactComponent };